export const mergeRight = <O1>(obj1: O1) => <O2>(obj2: O2): O1 & O2 => ({
  ...obj1,
  ...obj2,
});

export const mergeLeft = <O1>(obj1: O1) => <O2>(obj2: O2): O2 & O1 => ({
  ...obj2,
  ...obj1,
});
